/* Mega Menu */
document.addEventListener('click', function(event) {
  const childLink = event.target.closest('.mr-mega-menu__child-link, .mr-mega-menu__panel-title');

  if (childLink) {
    event.stopPropagation();
    window.location.href = childLink.href;
    return;
  }

  const tab = event.target.closest('.mr-mega-menu .mr-mega-menu__tab');
  if (!tab) return;

  event.preventDefault();
  event.stopPropagation();

  const menu = tab.closest('.mr-mega-menu');
  const index = tab.dataset.mrMegaTab;

  menu.querySelectorAll('.mr-mega-menu__tab').forEach(button => {
    button.classList.remove('is-active');
  });

  menu.querySelectorAll('.mr-mega-menu__panel').forEach(panel => {
    panel.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  const activePanel = menu.querySelector('[data-mr-mega-panel="' + index + '"]');

  if (activePanel) {
    activePanel.classList.add('is-active');
  }
}, true);




/* Media Gallery Video Button */
const mrOriginalSlideHTML = new WeakMap();

function restoreMediaGallerySlides(slideshowComponent) {
  if (!slideshowComponent) return;

  slideshowComponent.querySelectorAll('slideshow-slide').forEach(function(slide) {
    if (mrOriginalSlideHTML.has(slide)) {
      slide.innerHTML = mrOriginalSlideHTML.get(slide);
      slide.classList.remove('mr-video-slide-active');
      mrOriginalSlideHTML.delete(slide);
    }
  });
}

/* Restore normal image slides when clicking normal thumbnails */
document.addEventListener('click', function(event) {
  const normalThumb = event.target.closest(
    '.slideshow-controls__thumbnail:not(.slideshow-controls__thumbnail--youtube)'
  );

  if (!normalThumb) return;

  const slideshowComponent = normalThumb.closest('slideshow-component');
  if (!slideshowComponent) return;

  restoreMediaGallerySlides(slideshowComponent);
}, true);

/* Replace current visible media with video */
document.addEventListener('click', function(event) {
  const videoThumb = event.target.closest('.slideshow-controls__thumbnail--youtube');
  if (!videoThumb) return;

  event.preventDefault();
  event.stopPropagation();

  const videoType = videoThumb.dataset.videoType;
  const videoId = videoThumb.dataset.videoId;

  if (!videoType || !videoId) return;

  const slideshowComponent = videoThumb.closest('slideshow-component');
  if (!slideshowComponent) return;

  restoreMediaGallerySlides(slideshowComponent);

  const activeMedia =
    slideshowComponent.querySelector('slideshow-slide[aria-hidden="false"]') ||
    slideshowComponent.querySelector('slideshow-slide[aria-selected="true"]') ||
    slideshowComponent.querySelector('slideshow-slide.is-active') ||
    slideshowComponent.querySelector('slideshow-slide');

  if (!activeMedia) return;

  if (!mrOriginalSlideHTML.has(activeMedia)) {
    mrOriginalSlideHTML.set(activeMedia, activeMedia.innerHTML);
  }

  let iframeSrc = '';

  if (videoType === 'youtube') {
    iframeSrc = `https://www.youtube.com/embed/${videoId.trim()}?autoplay=1&rel=0&playsinline=1`;
  }

  if (videoType === 'vimeo') {
    iframeSrc = `https://player.vimeo.com/video/${videoId.trim()}?autoplay=1`;
  }

  if (!iframeSrc) return;

  activeMedia.classList.add('mr-video-slide-active');

  activeMedia.innerHTML = `
    <div class="product-youtube-video-wrapper">
      <iframe
        src="${iframeSrc}"
        title="Product video"
        frameborder="0"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  `;

  slideshowComponent.querySelectorAll('.slideshow-controls__thumbnail').forEach(function(button) {
    button.removeAttribute('aria-selected');
  });

  videoThumb.setAttribute('aria-selected', 'true');
}, true);


/* Price Range Slider Filter - AJAX without changing URL */
document.addEventListener('input', function(event) {
  const input = event.target.closest('[data-price-min-range], [data-price-max-range]');
  if (!input) return;

  const slider = input.closest('[data-price-range-slider]');
  if (!slider) return;

  updatePriceRangeSlider(slider, 'range');
});

document.addEventListener('change', function(event) {
  const input = event.target.closest('[data-price-min-range], [data-price-max-range]');
  if (!input) return;

  const slider = input.closest('[data-price-range-slider]');
  if (!slider) return;

  updatePriceRangeSlider(slider, 'range');
  fetchPriceFilteredProducts(slider);
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-price-range-slider]').forEach(function(slider) {
    updatePriceRangeSlider(slider);
  });
});

document.addEventListener('input', function(event) {
  const input = event.target.closest('[data-price-min-input], [data-price-max-input]');
  if (!input) return;

  const slider = input.closest('[data-price-range-slider]');
  if (!slider) return;

  updatePriceRangeSlider(slider, 'amounts');
});

document.addEventListener('change', function(event) {
  const input = event.target.closest('[data-price-min-input], [data-price-max-input]');
  if (!input) return;

  const slider = input.closest('[data-price-range-slider]');
  if (!slider) return;

  updatePriceRangeSlider(slider, 'amounts');
  fetchPriceFilteredProducts(slider);
});

function updatePriceRangeSlider(slider, source) {
  const minRange = slider.querySelector('[data-price-min-range]');
  const maxRange = slider.querySelector('[data-price-max-range]');
  const minHidden = slider.querySelector('[data-price-min-hidden]');
  const maxHidden = slider.querySelector('[data-price-max-hidden]');
  const minLabel = slider.querySelector('[data-price-min-label]');
  const maxLabel = slider.querySelector('[data-price-max-label]');
  const minAmountInput = slider.querySelector('[data-price-min-input]');
  const maxAmountInput = slider.querySelector('[data-price-max-input]');

  if (!minRange || !maxRange || !minHidden || !maxHidden) return;

  const currencySymbol = slider.dataset.currencySymbol || '£';
  const vatMultiplier = Number(slider.dataset.vatMultiplier || 1.2);
  const rangeMax = parseFloat(slider.dataset.rangeMax || maxRange.max || 0);

  let minExVat;
  let maxExVat;

  if (source === 'amounts') {
    minExVat = parseFloat(minAmountInput?.value || 0);
    maxExVat = parseFloat(maxAmountInput?.value || rangeMax);
  } else {
    minExVat = parseFloat(minRange.value || 0);
    maxExVat = parseFloat(maxRange.value || rangeMax);
  }

  minExVat = Math.max(0, Math.min(minExVat, rangeMax));
  maxExVat = Math.max(0, Math.min(maxExVat, rangeMax));

  if (minExVat > maxExVat) {
    if (source === 'amounts' && document.activeElement === minAmountInput) {
      maxExVat = minExVat;
    } else if (source === 'amounts' && document.activeElement === maxAmountInput) {
      minExVat = maxExVat;
    } else if (minRange === document.activeElement) {
      maxExVat = minExVat;
    } else {
      minExVat = maxExVat;
    }
  }

  minExVat = Math.round(minExVat);
  maxExVat = Math.round(maxExVat);

  minRange.value = minExVat;
  maxRange.value = maxExVat;

  if (source !== 'amounts') {
    if (minAmountInput) minAmountInput.value = minExVat;
    if (maxAmountInput) maxAmountInput.value = maxExVat;
  }

  const minIncVat = Math.round(minExVat * vatMultiplier);
  const maxIncVat = Math.round(maxExVat * vatMultiplier);

  minHidden.value = minExVat > 0 ? minIncVat : '';
  maxHidden.value = maxExVat < rangeMax ? maxIncVat : '';

  if (minLabel) {
    minLabel.textContent = currencySymbol + minExVat + ' Ex. VAT';
  }

  if (maxLabel) {
    maxLabel.textContent = currencySymbol + maxExVat + ' Ex. VAT';
  }

  const leftPercent = rangeMax > 0 ? (minExVat / rangeMax) * 100 : 0;
  const rightPercent = rangeMax > 0 ? 100 - (maxExVat / rangeMax) * 100 : 0;

  slider.style.setProperty('--range-left', leftPercent + '%');
  slider.style.setProperty('--range-right', rightPercent + '%');
}

function fetchPriceFilteredProducts(slider) {
  const minHidden = slider.querySelector('[data-price-min-hidden]');
  const maxHidden = slider.querySelector('[data-price-max-hidden]');

  if (!minHidden || !maxHidden) return;

  const url = new URL(window.location.href);

  url.searchParams.delete('page');

  url.searchParams.delete(minHidden.name);
  url.searchParams.delete(maxHidden.name);

  if (minHidden.value !== '') {
    url.searchParams.set(minHidden.name, minHidden.value);
  }

  if (maxHidden.value !== '') {
    url.searchParams.set(maxHidden.name, maxHidden.value);
  }

  fetch(url.toString(), {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      replaceElement(parsedHTML, '#product-grid');
      replaceElement(parsedHTML, '[data-product-grid]');
      replaceElement(parsedHTML, '.product-grid');
      replaceElement(parsedHTML, '.collection-product-grid');

      replaceElement(parsedHTML, '#facets');
      replaceElement(parsedHTML, '.facets');
      replaceElement(parsedHTML, 'facet-filters-form');

      document.dispatchEvent(new CustomEvent('price-range-filter:updated'));
    })
    .catch(function(error) {
      console.error('Price range filter failed:', error);
    });
}

function replaceElement(parsedHTML, selector) {
  const newElement = parsedHTML.querySelector(selector);
  const currentElement = document.querySelector(selector);

  if (!newElement || !currentElement) return false;

  currentElement.innerHTML = newElement.innerHTML;

  return true;
}